<div class="container mt-4">
  <div class="d-flex justify-content-between align-items-center mb-4">
    <h1>Relatório de Contas a Pagar – Detalhado</h1>
    <span *ngIf="carregado && relatorio" class="badge bg-secondary">Total: {{ relatorio.totalRegistros }}</span>
  </div>
  <hr />

  <!-- Filtros -->
  <div class="row g-2 align-items-end mb-3 no-print">
    <div class="col-md-2">
      <label class="form-label">Data Inicial <span class="text-danger">*</span></label>
      <input type="date" class="form-control campo-obrigatorio" required
             [class.is-invalid]="dataInicialInvalida"
             [(ngModel)]="dataInicial" />
      <div class="invalid-feedback" *ngIf="dataInicialInvalida">
        Informe a data inicial.
      </div>
    </div>
    <div class="col-md-2">
      <label class="form-label">Data Final <span class="text-danger">*</span></label>
      <input type="date" class="form-control campo-obrigatorio" required
             [class.is-invalid]="dataFinalInvalida"
             [(ngModel)]="dataFinal" />
      <div class="invalid-feedback" *ngIf="dataFinalInvalida">
        Informe a data final.
      </div>
    </div>
    <div class="col-md-2">
      <label class="form-label">Tipo de Data <span class="text-danger">*</span></label>
      <select class="form-select" [(ngModel)]="tipoData">
        <option value="PAGAMENTO">Pagamento</option>
        <option value="VENCIMENTO">Vencimento</option>
      </select>
    </div>
    <div class="col-md-2">
      <label class="form-label">Grupo</label>
      <select class="form-select" [(ngModel)]="grupoId" (ngModelChange)="onGrupoChange()">
        <option [value]="0">Todos</option>
        <option *ngFor="let g of grupos" [value]="g.id">{{ g.nome }}</option>
      </select>
    </div>
    <div class="col-md-2">
      <label class="form-label">Subgrupo</label>
      <select class="form-select" [(ngModel)]="subgrupoId">
        <option [value]="0">Todos</option>
        <option *ngFor="let s of subgruposFiltrados" [value]="s.id">{{ s.nome }}</option>
      </select>
    </div>
    <div class="col-md-2">
      <label class="form-label">Fornecedor</label>
      <select class="form-select" [(ngModel)]="fornecedorId">
        <option [value]="0">Todos</option>
        <option *ngFor="let f of fornecedores" [value]="f.id">{{ f.nomeFantasia || f.razaoSocial }}</option>
      </select>
    </div>
    <div class="col-md-3 ms-md-auto d-flex gap-2">
      <button class="btn btn-primary w-100" (click)="buscar()" [disabled]="carregando">
        <span *ngIf="carregando" class="spinner-border spinner-border-sm me-1"></span>
        Buscar
      </button>
      <button class="btn btn-outline-secondary w-100" (click)="limpar()" [disabled]="carregando">
        Limpar
      </button>
    </div>
  </div>

  <div class="alert alert-warning no-print mb-3"
       *ngIf="tentouBuscar && (!dataInicial || !dataFinal)">
    Informe a data inicial e a data final para gerar o relatório.
  </div>

  <div *ngIf="carregando" class="alert alert-info no-print" role="alert">
    Carregando relatório...
  </div>

  <!-- Resultados -->
  <div *ngIf="carregado && relatorio">

    <div class="d-flex justify-content-end mb-2 no-print">
      <button class="btn btn-outline-dark btn-sm" (click)="imprimir()">Imprimir Relatório</button>
    </div>

    <!-- Cabeçalho visível apenas na impressão -->
    <div class="print-header print-only">
      <div class="print-header-title">Relatório de Contas a Pagar – Detalhado</div>
      <div class="print-header-meta">
        <span>
          Período: {{ dataInicial | date:'dd/MM/yyyy' }} a {{ dataFinal | date:'dd/MM/yyyy' }}
        </span>
        <span class="print-header-sep"> | Tipo: {{ tipoData }}</span>
        <span class="print-header-sep"> | Total: {{ relatorio.totalRegistros }} registro(s)</span>
        <span class="print-header-sep"> | Gerado em: {{ dataGeracao }}</span>
      </div>
      <div class="print-header-divider"></div>
    </div>

    <div *ngIf="relatorio.itens.length === 0" class="text-center text-muted py-4">
      Nenhum registro encontrado para os filtros selecionados.
    </div>

    <div class="table-responsive" *ngIf="relatorio.itens.length > 0">
      <table class="table table-striped table-hover print-table">
        <thead class="table-dark">
          <tr>
            <th scope="col">Id</th>
            <th scope="col">Fornecedor</th>
            <th scope="col">Grupo</th>
            <th scope="col">Subgrupo</th>
            <th scope="col">Descrição</th>
            <th scope="col">Destino</th>
            <th scope="col" class="text-center">Dt. Pagamento</th>
            <th scope="col" class="text-end">Vlr. Pago</th>
            <th scope="col" class="text-center">Status</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of relatorio.itens">
            <td>{{ item.id }}</td>
            <td>{{ item.fornecedor }}</td>
            <td>{{ item.grupo }}</td>
            <td>{{ item.subgrupo }}</td>
            <td>{{ item.descricao }}</td>
            <td>{{ item.destino }}</td>
            <td class="text-center text-nowrap">{{ item.dataPagamento | date:'dd/MM/yyyy' }}</td>
            <td class="text-end text-nowrap fw-bold">{{ item.valorPago | currency:'BRL' }}</td>
            <td class="text-center">
              <span class="status-badge"
                [class.status-pago]="item.status === 'PAGO'"
                [class.status-aguardando]="item.status === 'AGUARDANDO'"
                [class.status-vencido]="item.status === 'VENCIDO'"
                [class.status-cancelado]="item.status === 'CANCELADO'">
                {{ item.status }}
              </span>
            </td>
          </tr>
        </tbody>
        <tfoot>
          <tr class="print-totals">
            <td colspan="6" class="text-end fw-bold">Total do período:</td>
            <td class="text-end fw-bold">{{ totalValorPago | currency:'BRL' }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
    </div>

  </div>
</div>
